import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import WhoWeAreImg1 from "../../assets/images/whoWeAreImg1.png";
import whoWeAreImg2 from "../../assets/images/aboutSectionImg2.png";
import whoWeAreImg3 from "../../assets/images/aboutSectionImg1.png";

const NewAboutWhoWeAre = () => {
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;
  return (
    <div
      className={`${
        theme === "dark" ? "bg-primary" : "bg-[#141414]"
      } transition-all duration-500`}
    >
      <div
        className={`${
          theme === "dark" ? "" : ""
        }  max-w-screen-2xl mx-auto px-5 sm:px-20 py-8 sm:py-28`}
      >
        <div className="flex flex-col px-4 sm:px-32 text-center self-end relative">
          <h2 className="text-[32px] bricolage-grotesque-bold text-secondary mb-4 sm:mb-8 sm:text-5xl">
            Who We Are
          </h2>
          <p className="sm:text-xl mb-4 text-white font-gtAmerica">
            We are a group of innovative thinkers and doers who go above and
            beyond to help our clients achieve their goals. One thing that sets
            us apart from the competition is our understanding of how crucial it
            is for entrepreneurs to remain competitive in every way. We
            recognize the grind that goes into all of this. And for that reason,
            we are here.
          </p>

          <p className="sm:text-xl text-white font-gtAmerica">
            We think that creativity and technology go hand in hand. By
            combining both, we help businesses build a strong foundation and
            stay ahead in a world that’s always evolving.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-10 items-center justify-center mt-10">
          <img
            src={WhoWeAreImg1}
            className="h-[400px] object-cover w-full sm:w-[20%]"
            alt=""
          />
          <img
            src={whoWeAreImg2}
            className="col-span-2 h-[400px] object-cover w-full sm:w-[40%]"
            alt=""
          />
          <img
            src={whoWeAreImg3}
            className="h-[400px] object-cover w-full sm:w-[20%]"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default NewAboutWhoWeAre;
